(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["recipe-featured-day"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('.featured-recipe');
  if (!section) return;

  const closeAll = () => {
    section.querySelectorAll('.fr-hotspot.is-open').forEach(btn => {
      btn.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
    });
  };

  section.querySelectorAll('.fr-hotspot').forEach(btn => {
    const pop = btn.querySelector('.fr-pop');

    btn.addEventListener('click', (e) => {
      e.preventDefault();

      if (!btn.classList.contains('is-open')) {
        closeAll();
        btn.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      } else if (!pop.contains(e.target)) {
        btn.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
      }
    });

    // Close when clicking outside
    document.addEventListener('click', (e) => {
      if (!btn.contains(e.target)) {
        btn.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
